<script>
  export let name;
  export let prefix;
  export let required;
  export let value;

  import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	function handleInput(e) {
		dispatch('inputChange', {
      name,
      prefix,
			value: e.target.value
		});
	};

  function capitalize (name) {
    if (name === undefined || typeof name !== 'string') return '';
     return name.charAt(0).toUpperCase() + name.slice(1);
  };

  let placeholder = `${capitalize(name)} ${prefix}`;
  let label = `${name.toUpperCase()} ${prefix}`;

</script>

<div class="field-container">
      <input bind:value={value} on:input={handleInput} type="number" class="field" {required} {placeholder} />
      <label class="floating-label">{label}</label>
      <div class="field-underline"></div>
</div>


<style>
  .field-container {
    position: relative;
    margin: 0 auto;
    width: 400px;
    margin-top: 30px;
  }

  .field {
    display: block;
    width: 100%;
    padding: 15px 10px 0;
    border: none;
    font-size: 14px;
  }

  .field:focus {
    outline: 0;
  }

  .floating-label {
    position: absolute;
    pointer-events: none;
    top: 5px;
    left: 10px;
    font-size: 10px;
    opacity: 0;
    background-color: white;
    padding: 0 2px;
    -webkit-transition: 0.2s ease-in-out;
    transition: 0.2s ease-in-out;
  }

  .field:valid+.floating-label {
    opacity: 1;
    top: -5px;
    color: #9e9e9e;
    text-transform: uppercase;
  }

  .field:focus+.floating-label {
    color: #03a9f4;
  }

  .field-underline {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: -5px;
    border: 1px solid #9e9e9e;
    z-index: -1;
    padding: 10px 10px 0;
  }

  .field:focus+.floating-label+.field-underline {
    border-color: #03a9f4;
  }

</style>